import { gql } from "graphql-tag";

export const heroCarouselV2 = gql`
  fragment Home_page_v2_hero_carousel_v2 on Home_page_v2SlicesHero_carousel_v2 {
    type
    variation {
      ... on Home_page_v2SlicesHero_carousel_v2Default {
        primary {
          time_interval
        }
        items {
          campaign_sale_link {
            ... on Campaign_sale1 {
              _meta {
                uid
              }
            }
          }
        }
      }
    }
  }
`;
